import { Component, Input, OnInit } from '@angular/core';
// clickOutside.directive.ts
import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  constructor(private elementRef: ElementRef) { }

  @Output()
  public clickOutside = new EventEmitter();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any): void {
    const isClickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!isClickedInside) {
      this.clickOutside.emit();
    }
  }
}

@Component({
    selector: 'app-year-picker',
    templateUrl: './year-picker.component.html',
    styleUrls: ['./year-picker.component.scss'],
    standalone: false
})
export class YearPickerComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  startYear: number = Math.max(this.currentYear - 11, 1900);
  endYear: number = Math.min(this.startYear + 11, this.currentYear);
  selectedYear: string = '';
  years: number[] = [];
  @Input() selectedYearFromResume: string;
  @Output() selectedYearChange = new EventEmitter<string>();

  ngOnInit(): void {
    this.updateYearDisplay(this.startYear);
    if (this.selectedYearFromResume) {
      this.selectedYear = this.selectedYearFromResume;
    }
  }

  generateYearList(startYear: number, endYear: number): number[] {
    const yearList: number[] = [];
    for (let year = startYear; year <= endYear; year++) {
      yearList.push(year);
    }
    return yearList;
  }

  updateYearDisplay(startYear: number): void {
    this.startYear = startYear;
    this.endYear = Math.min(startYear + 13, this.currentYear + 2);    
    this.years = this.generateYearList(startYear, this.endYear);

  }

  previousYears(): void {
    this.updateYearDisplay(this.startYear - 12);
  }

  nextYears(): void {
    this.updateYearDisplay(this.startYear + 12);
  }

  selectYear(year: number): void {
    this.selectedYear = year.toString();
    // Add your logic for handling the selected year here
    // For now, let's just log it to the console
    this.selectedYearChange.emit(this.selectedYear);
    // this.selectedYear = year;
    this.isPopoverOpen = false;
  }


  isPopoverOpen = false;
  // selectedYear: string = '';

  togglePopover(): void {
    event.stopPropagation();
    this.isPopoverOpen = !this.isPopoverOpen;

  }

  closePopover(): void {
    if (!this.selectedYear) {
      // this.isPopoverOpen = false;
    }
  }

  // selectYear(year: number): void {
  //   this.selectedYear = year.toString();
  //   this.isPopoverOpen = false;
  // }
}
